import { RootState } from 'app/store/rootReducer';
import { selectIsInFirstStepMode } from 'app/store/data/formsConfig';
import {
  isPrerendering,
  wasPrerendered,
} from 'app/shared/helpers/isPrerendering';
import isBot from 'app/shared/helpers/isBot';
import { isCalculationFormPath } from 'app/shared/helpers/isCalculationFormPath';
import { selectIsFormMicroCenterActive } from 'app/store/selectors/selectIsFormMicroCenterActive';

export const selectIsFirstStepModeUnknown = (state: RootState) =>
  !isPrerendering &&
  !wasPrerendered &&
  !isBot() &&
  selectIsInFirstStepMode(state) === undefined &&
  selectIsFormMicroCenterActive(state) &&
  isCalculationFormPath(window.location.pathname);
